import { render, staticRenderFns } from "./UP.vue?vue&type=template&id=fd315d54&scoped=true&"
import script from "./UP.vue?vue&type=script&lang=js&"
export * from "./UP.vue?vue&type=script&lang=js&"
import style0 from "./UP.vue?vue&type=style&index=0&id=fd315d54&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd315d54",
  null
  
)

export default component.exports